import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import {
    Typography, TableRow, TableCell, Table,
    TableBody, TableHead, Button, Divider
} from "@mui/material";
import { ReactComponent as Image } from '../../../../assets/Icons/image.svg';
import { ReactComponent as Document } from '../../../../assets/Icons/document.svg';
import { ReactComponent as Folder } from '../../../../assets/Icons/folder.svg';
import { ReactComponent as Trash } from '../../../../assets/Icons/trash.svg';
import { ReactComponent as CloudUpload } from '../../../../assets/Icons/cloudUpload.svg';
import { ReactComponent as Search } from '../../../../assets/Icons/search.svg';
import TextFieldComponent from "../../../../components/TextField";
import Moment from 'react-moment';
import Checkbox from "../../../../components/Checkbox";
import AccessRowAut from "./AccessRowAut";
import PaginationCustom from "../../../../components/Pagination";
import { changeDocPage, getDocuments } from "../../../../redux/DocumentDuck";
import File from "../../../../components/File";
import "./SecondStep.css";
import { useTranslation } from 'react-i18next';
const SecondStep = ({ setValues, authorization, error }) => {
    const { t } = useTranslation(['authorization', 'common', 'file']);
    const pagesDoc = useSelector(store => store.doc.pagesDoc);
    const activePageDoc = useSelector(store => store.doc.activePageDoc);
    const documents = useSelector(store => store.doc.documents);
    const isCreatedFile = useSelector(store => store.doc.isCreatedFile);

    const [resetPageDoc, setResetPageDoc] = useState(false);
    const [search, setSearch] = useState('');
    const [openFile, setOpenFile] = useState(false);
    const [selectedDocs, setSelectedDocs] = useState([]);
    const [activePageSelectedDoc, setActivePageSelectedDoc] = useState(0);
    const dispatch = useDispatch();

    const obj_per_page = 10;
    const imageExtensions = [".JPG", ".JPEG", ".GIF", ".PNG", ".TIFF",
        ".TIF", ".RAW", ".BMP", ".PSD", ".EPS", ".PIC",
        ".MOV", ".MKV", ".MP4", ".WMV", ".FLV"];

    const onChangeSearch = e => {
        setSearch(e.target.value);
        setResetPageDoc(true);
    };

    //componentDidMount
    useEffect(() => {
        dispatch(changeDocPage(1));
        //component will unmount
        return () => {
            dispatch(changeDocPage(1));
        }
    }, [dispatch]);

    const onSwitch = (value, event) => {
        const { checked } = event.target;
        const list = authorization.selectedFiles;
        if (!checked) {
            const doc = list.find(d => String(d.id) === String(value));
            const index = list.indexOf(doc);
            index > -1 && list.splice(index, 1);
            if (!list[activePageSelectedDoc * obj_per_page] && activePageSelectedDoc > 0) {
                setActivePageSelectedDoc(activePageSelectedDoc - 1);
            }
        }
        else {
            const doc = documents.find(d => String(d.id) === String(value));
            list.push(doc);
        }
        setValues({ ...authorization, selectedFiles: list });
    };

    const removeFile = (id) => {
        const list = authorization.selectedFiles;
        const doc = list.find(d => String(d.id) === String(id));
        const index = list.indexOf(doc);
        index > -1 && list.splice(index, 1);
        setValues({ ...authorization, selectedFiles: list });
        if (!list[activePageSelectedDoc * obj_per_page] && activePageSelectedDoc > 0) {
            setActivePageSelectedDoc(activePageSelectedDoc - 1);
        }
    };

    const onSearchDoc = useCallback((searchDoc) => {
        const timer = setTimeout(() => {
            const page = resetPageDoc ? 0 : activePageDoc;
            const filterBy = [{ search: String(authorization.clientId), filterBy: 'client' }];
            searchDoc !== '' && filterBy.push({ search: searchDoc, filterBy: 'search-bar-authorization' });
            dispatch(getDocuments(filterBy, "recent-files", page, obj_per_page, true, 'authorization'));
            setResetPageDoc(false);
        }, 1000);
        return () => clearTimeout(timer);
        // eslint-disable-next-line
    }, [dispatch]);

    useEffect(() => {
        const page = resetPageDoc ? 0 : activePageDoc;
        const filterBy = [{ search: String(authorization.clientId), filterBy: 'client' }];
        search !== '' && filterBy.push({ search: search, filterBy: 'search-bar-authorization' });
        dispatch(getDocuments(filterBy, "recent-files", page, obj_per_page, true, 'authorization'));
        setResetPageDoc(false);
        // eslint-disable-next-line
    }, [dispatch, activePageDoc]);

    useEffect(() => {
        if (isCreatedFile)
            onSearchDoc(search);
        // eslint-disable-next-line
    }, [onSearchDoc, isCreatedFile]);

    useEffect(() => {
        onSearchDoc(search);
        // eslint-disable-next-line
    }, [onSearchDoc]);

    const totalNumPages = () => {
        return Math.ceil(authorization.selectedFiles.length / obj_per_page);
    };

    const changeSelectedDocPage = (page) => {
        setActivePageSelectedDoc(page - 1);
    };

    const drawRowSelectedDocs = useCallback((page, selectedFiles) => {
        const list = [];
        for (let index = page * obj_per_page; index < (page * obj_per_page) + obj_per_page; index++) {
            if (selectedFiles.length > index) {
                list.push(selectedFiles[index]);
            }
        }
        setSelectedDocs(prev => ([...list]));
    }, []);

    useEffect(() => {
        drawRowSelectedDocs(activePageSelectedDoc, authorization.selectedFiles);
        // eslint-disable-next-line 
    }, [drawRowSelectedDocs, activePageSelectedDoc, authorization.selectedFiles.length]);

    return (
        <div>
            <File open={openFile} closeFile={() => setOpenFile(false)} clientId={authorization.clientId} />
            <div className="container-app-div">
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 42 }}>
                    <Typography className="app-form-title">{t("subtitle7")}</Typography>
                    <Button className='button-app-create' variant="text" startIcon={<CloudUpload />}
                        onClick={() => setOpenFile(true)}>
                        {t("file:title")}
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '85%' }}>
                        <TextFieldComponent Icon={<Search />} position='start'
                            placeholder={t("searchDocLbl")}
                            valueInput={search}
                            callback={onChangeSearch.bind(this)}
                        />
                    </div>
                    <div>
                        <Button variant="contained" className="button-app-save"
                            onClick={() => onSearchDoc(search)}>
                            {t("common:commonSearchPlh")}
                        </Button>
                    </div>
                </div>
                <Divider className="divider-line" style={{ marginTop: 26, marginBottom: 29 }} />
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ width: '35%' }}>
                        <Typography className="doc-title-text">{t("subtitle8")}</Typography>
                    </div>
                </div>
                <Divider className="divider-line" style={{ marginTop: 29 }} />
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className='table-app-title-header'>{t("headerTbl1")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl2")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl3")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl4")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl5")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {documents.length === 0 &&
                            <TableRow key='empty'>
                                <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                    {t("common:commonNoResultsLbl")}
                                </TableCell>
                            </TableRow>
                        }
                        {documents.map(item => (
                            <TableRow key={item.id}>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Checkbox
                                            name='documents'
                                            onChange={onSwitch.bind(this, item.id)}
                                            value={!!authorization.selectedFiles.find(f => String(f.id) === String(item.id))}
                                            checkboxCheckedValue={true}
                                        />
                                        <AccessRowAut
                                            title={item.fileName}
                                            Icon={imageExtensions.includes(item.fileExtension.toUpperCase().trim())
                                                ? Image : Document}
                                        />
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row"  >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Folder style={{ marginRight: '10.14px' }} />
                                        <Typography className='folder-title-cel-text'>
                                            {item.folder.name}
                                        </Typography>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    {item.uploadedByUser.firstName + ' ' + item.uploadedByUser.lastName}
                                </TableCell>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    {item.fileExtension.replace(".", "").toUpperCase()}
                                </TableCell>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    <Moment className="app-form-subtitle" style={{ marginTop: '4px' }}
                                        format="DD/MM/YYYY">
                                        {item.created}
                                    </Moment>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div style={{ marginTop: 24 }}>
                    <PaginationCustom pages={pagesDoc} activePage={activePageDoc}
                        onChange={page => dispatch(changeDocPage(page))} />
                </div>
            </div>
            <div className="container-app-div">
                <Typography className="app-form-title">{t("subtitle9")}</Typography>
                <Table aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell className='table-app-title-header'>{t("headerTbl1")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl2")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl3")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl4")}</TableCell>
                            <TableCell className='table-app-title-header'>{t("headerTbl5")}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {selectedDocs.length === 0 &&
                            <TableRow key='empty'>
                                <TableCell colSpan={5} style={{ textAlign: 'center' }}>
                                    {t("subtitle9b")}
                                </TableCell>
                            </TableRow>
                        }
                        {selectedDocs.map(item => (
                            <TableRow key={item.id}>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <AccessRowAut
                                            title={item.fileName}
                                            Icon={imageExtensions.includes(item.fileExtension.toUpperCase().trim())
                                                ? Image : Document}
                                        />
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row"  >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <Folder style={{ marginRight: '10.14px' }} />
                                        <Typography className='folder-title-cel-text'>
                                            {item.folder.name}
                                        </Typography>
                                    </div>
                                </TableCell>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    {item.uploadedByUser.firstName + ' ' + item.uploadedByUser.lastName}
                                </TableCell>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    {item.fileExtension.replace(".", "").toUpperCase()}
                                </TableCell>
                                <TableCell component="th" scope="row" className='app-form-subtitle'>
                                    <div>
                                        <Moment className="app-form-subtitle" style={{ marginTop: '4px' }}
                                            format="DD/MM/YYYY">
                                            {item.created}
                                        </Moment>
                                        <Trash style={{ marginLeft: '20.14px', cursor: 'pointer' }}
                                            className="authorizations-icon-svg-delete authorizations-icon-delete"
                                            onClick={() => removeFile(item.id)} />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div style={{ marginTop: 24 }}>
                    <PaginationCustom pages={totalNumPages()} activePage={activePageSelectedDoc}
                        onChange={page => changeSelectedDocPage(page)} />
                </div>
                {error.selectedFiles &&
                    <p className='app-error-text'>{error.selectedFiles}</p>
                }
            </div>
        </div>
    );
}

export default SecondStep;